import axios from 'axios'
import router from '@/router/'
import { Toast } from 'vant'

function errorCatch (data) {
  if (/debug/.test(data.config.url)) return false
  // eslint-disable-next-line no-unused-vars
  const content = `${data.config.url}:${data.data.message},params:${data.config.data} }`
}
const Axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 0
})

Axios.interceptors.request.use(config => {
  config.headers['x-auth-token'] = localStorage.getItem('x-auth-token')
  config.headers['x-version'] = process.env.VUE_APP_VERSION
  config.headers['x-package-name'] = process.env.VUE_APP_PACKAGE_NAME
  config.headers['x-adid'] = localStorage.getItem('adid')
  config.headers['x-latitude'] = localStorage.getItem('latitude')
  config.headers['x-longitude'] = localStorage.getItem('longitude')
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(response => {
  const code = response.data.code
  if (response.headers && response.headers['x-client-ip']) {
    localStorage.setItem('x-client-ip', response.headers['x-client-ip'])
  }
  if (code === '-1') {
    localStorage.removeItem('x-auth-token')
    Toast('Please login again')
    router.push({ name: 'RefuseRegisterPage' })
  }
  if (code === '99') {
    Toast(response.data.message)
    Toast({
      message: response.data.message,
      position: 'bottom'
    })
    errorCatch(response)
  }
  if (code === '500') {
    Toast('The system is experiencing problems, please try again later')
    errorCatch(response)
  }
  return response.data
}, error => {
  if (error.message.includes('timeout')) {
    Toast('Oops, connecting to the server failed')
  }
  Toast('Oops, connecting to the server failed')
  return Promise.reject(error)
})
export default Axios
